<template>
  <div>
    <v-skeleton-loader v-if="$vuetify.breakpoint.mdAndUp"
      type="image"
      class="mx-auto image-loader-desk mb-2"
      :height="$vuetify.breakpoint.lgAndUp ? 350 : 280">
    </v-skeleton-loader>

    <div class="pt-1 px-1" v-else>
      <v-card class="mx-auto">
        <v-skeleton-loader
          type="image"
          class="mx-auto image-loader-desk mb-2"
          height="170">
        </v-skeleton-loader>
      </v-card>
    </div>

    <v-row justify="center" class="pt-4 pl-sm-4 pr-sm-4" no-gutters>
      <v-col xl="9" lg="11" md="10" sm="12" cols="10">
        <v-row no-gutters v-if="$vuetify.breakpoint.smAndUp">
          <v-col class="pr-xl-4 pr-lg-4 pr-md-4 pr-sm-2" cols="3">
            <v-card outlined>
              <v-skeleton-loader
                type="list-item-avatar-two-line"
                class="mx-auto">
              </v-skeleton-loader>
            </v-card>
          </v-col>
          <v-col class="px-xl-2 px-lg-2 px-md-2 px-sm-1" cols="3">
            <v-card outlined>
              <v-skeleton-loader
                type="list-item-avatar-two-line"
                class="mx-auto">
              </v-skeleton-loader>
            </v-card>
          </v-col>
          <v-col class="pl-xl-4 pl-lg-4 pl-md-4 pl-sm-2" cols="3">
            <v-card outlined>
              <v-skeleton-loader
                type="list-item-avatar-two-line"
                class="mx-auto">
              </v-skeleton-loader>
            </v-card>
          </v-col>
          <v-col class="pl-xl-4 pl-lg-4 pl-md-4 pl-sm-2" cols="3">
            <v-card outlined>
              <v-skeleton-loader
                type="list-item-avatar-two-line"
                class="mx-auto">
              </v-skeleton-loader>
            </v-card>
          </v-col>
        </v-row>
        <v-row no-gutters v-else>
          <v-col class="pr-2" cols="3">
            <v-skeleton-loader
              type="avatar"
              class="mx-2 center-content">
            </v-skeleton-loader>
          </v-col>
          <v-col class="px-1" cols="3">
            <v-skeleton-loader
              type="avatar"
              class="mx-2 center-content">
            </v-skeleton-loader>
          </v-col>
          <v-col class="pl-2" cols="3">
            <v-skeleton-loader
              type="avatar"
              class="mx-2 center-content">
            </v-skeleton-loader>
          </v-col>
          <v-col class="pl-2" cols="3">
            <v-skeleton-loader
              type="avatar"
              class="mx-2 center-content">
            </v-skeleton-loader>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row justify="center" class="pt-4 pl-sm-4 pr-sm-4 pb-8" no-gutters v-if="$vuetify.breakpoint.smAndUp">
      <v-col xl="9" lg="11" md="10" sm="12" cols="10">
        <v-row class="pb-2" no-gutters v-for="i in 3" :key="i + '_slide'">
          <v-col cols="12">
            <v-sheet class="products-slide mx-auto py-1" >
              <v-slide-group center-active class="centered-slide">
                <template v-slot:prev>
                  <v-btn class="ml- blue--text" fab>
                    <v-icon dark>keyboard_arrow_left</v-icon>
                  </v-btn>
                </template>

                <template v-slot:next>
                  <v-btn class="blue--text" fab>
                    <v-icon dark>keyboard_arrow_right</v-icon>
                  </v-btn>
                </template>

                <v-slide-item v-for="i in 10" :key="i + '_slide-item'" class="py-1">
                  <v-skeleton-loader class="mx-2" width="224" type="card"></v-skeleton-loader>
                </v-slide-item>
              </v-slide-group>
            </v-sheet>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row justify="center" class="mt-6 pt-1 px-4" no-gutters v-else>
      <v-col cols="12">
        <v-row no-gutters v-for="i in 2" :key="i + '_row'">
          <v-col class="mb-6">
            <v-card class="mx-auto" elevation="7">
              <v-skeleton-loader v-for="i in 3" type="list-item-avatar-three-line" tile :key="i + '_item'"></v-skeleton-loader>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'HomeLoader'
}
</script>
<style scoped>
  .image-loader-desk >>> .v-skeleton-loader__image{
    height: 350px;
  }

  .center-content{
    display: flex;
    justify-content: center;
  }

  .centered-slide >>> .v-slide-group__content{
    display: flex;
    justify-content: center;
  }

  .products-slide{
    background: transparent;
  }

  .product-title{
    line-height: 1.375em;
  }

  @media only screen and (min-width: 600px) {
    .products-slide{
      max-width: 720px;
    }
  }

  @media only screen and (min-width: 1180px) {
    .products-slide{
      max-width: 960px;
    }
  }

  @media only screen and (min-width: 1264px) {
    .products-slide{
      max-width: 1065px;
    }
  }

  @media only screen and (min-width: 1464px) {
    .products-slide{
      max-width: 1304.25px;
    }
  }

  @media only screen and (min-width: 2100px) {
    .products-slide{
      max-width: 1543.5px;
    }
  }
</style>
